import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SeguridadService extends ApiService {
  constructor(http: HttpClient, authService: NbAuthService) {
    super(http, authService);
  }

  check(url: string): Observable<any> {
    return this.get<any>('/api/Menu/Check', { url });
  }

  setAuditoria(auditoria: infoAuditoria | undefined):Observable<any>{
    return this.post<any>('/api/Auditoria/PostCrearAuditoria',auditoria);
  }
}

export interface infoAuditoria {
  tFormulario?: string;
  tDescripcion?: string;
}
